enum MusicGenre {
  Cinematic = 'Cinematic',
  Upbeat = 'Upbeat',
  ChillOut = 'Chill-out',
  Disco = 'Disco',
  DrumAndBass = 'Drum & Bass',
  Dubstep = 'Dubstep',
  EDM = 'EDM',
  Funk = 'Funk',
  HipHop = 'Hip Hop',
  House = 'House',
  Latino = 'Latino',
  Reggae = 'Reggae',
  Techno = 'Techno',
  Trap = 'Trap'
}

export default MusicGenre;



// WEBPACK FOOTER //
// ./src/audio-editing/MusicGenre.ts